/**
 * Normalize list API payloads: bare array or Laravel paginator under `data`.
 */
export function normalizeListPayload(payload) {
  if (payload == null) {
    return { items: [], meta: null }
  }
  if (Array.isArray(payload)) {
    return { items: payload, meta: null }
  }
  if (Array.isArray(payload.data)) {
    return {
      items: payload.data,
      meta: {
        current_page: payload.current_page,
        last_page: payload.last_page,
        total: payload.total,
      },
    }
  }
  return { items: [], meta: null }
}
